import { Button, Col, Input, message, Row, Select, Tooltip } from "antd";
import React, { useEffect, useState } from "react";
import { getColumnFromSuite } from "../../../service/suite.service";
import {
  checkDate,
  checkFirstRowForEmptyColumn,
  checkNumeric,
  getDelimiter,
  getFirstRow,
} from "../../../helper/file_helper";
import TaskMapFields from "./TaskMapFields";
import {
  CheckOutlined,
  QuestionCircleOutlined,
  ArrowLeftOutlined,
} from "@ant-design/icons";

const { Option } = Select;
function FileToDbTask(props) {
  const [testSuiteId, setTestSuiteId] = useState("");
  const [fileType, setFileType] = useState("");
  const [fileContent, setFileContent] = useState("");
  const [controlDocument, setControlDocument] = useState("");
  const [file, setFile] = useState();
  const [sqlHeader, setSqlHeader] = useState([]);
  const [isOpen, setIsOpen] = useState(false);
  const [fileHeader, setFileHeader] = useState([]);
  const [matchType, setMatchType] = useState("");
  const [fileName, setFileName] = useState("");
  const [isGreen, setIsGreen] = useState(false);
  const [matchDisabled, setMatchDisabled] = useState(false);
  const [mappingData, setMappingData] = useState([]);
  const [mappingSelection, setMappingSelection] = useState([]);
  const [mapName, setMapName] = useState("");

  // Tell the modal when the mapping editor is open so it can swap its body
  // in-place (no modal-on-modal).
  useEffect(() => {
    props.onMapViewChange?.(isOpen);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOpen]);

  const getContent = (fileObject) => {
    if (fileObject) {
      const reader = new FileReader();
      reader.onload = (e) => {
        setFileContent(e.target.result);
      };
      reader.onerror = (e) => {
        console.error("Error reading file:", e.target.error);
      };
      reader.readAsText(fileObject);
    } else {
      console.log("No file selected");
    }
  };
  const onChangeTestSuite = (key, value) => {
    setTestSuiteId(value.value);
    setControlDocument(value.spec);
    getSuiteHeader(value.value);
  };
  const handleModal = () => {
    setIsOpen(!isOpen);
  };
  const onMappingClick = () => {
    // Clear prerequisites first — otherwise parsing empty content shows a
    // confusing "delimiter / header" error when nothing has been provided yet.
    if (!testSuiteId) {
      message.error("Select a test suite before you can map fields.");
      return;
    }
    if (!file || !fileContent) {
      message.error("Upload a sample file before you can map fields.");
      return;
    }
    if (!fileType) {
      message.error("Select the file delimiter before you can map fields.");
      return;
    }
    let delimiter = getDelimiter(fileContent);
    let isEmpty = checkFirstRowForEmptyColumn(fileContent, fileType);
    let header = [1, 2, 3];
    header = getFirstRow(fileContent, delimiter);
    setFileHeader(header);
    let isNumeric = checkNumeric(fileContent, delimiter);
    let isDate = checkDate(fileContent, delimiter);

    if (delimiter !== fileType || isEmpty) {
      message.error(
        "Check if the file delimiter matches the selection or if the header row is empty",
      );
    } else if (isNumeric || isDate) {
      message.error(
        "Check if there is a numeric or a date value in the header",
      );
    } else {
      handleModal();
    }
  };
  const mappingConfirmed = (key, tableData, mappingName, fieldTests, type) => {
    const hasData = tableData && tableData.length > 0;
    setIsGreen(hasData);
    // Persist mapping state to parent so reopening shows existing data
    props.setMappedData(hasData ? tableData : []);
    props.setMapName(mappingName || "");
    props.setMappingSelection(type === "new" ? "new" : "existing");
    props.saveFileToDbData(
      tableData,
      mappingName,
      testSuiteId,
      matchType,
      fileName,
      fileType,
      type,
    );
    setIsOpen(false);
  };
  const getSuiteHeader = (testSuiteId) => {
    getColumnFromSuite(testSuiteId, "Field Level").then((res) => {
      if (res.status === 200) {
        props.setSqlHeader(res.data);
        setSqlHeader(res.data);
      }
    });
  };
  // The mapping editor swaps the body in place. The fields are HIDDEN (not
  // unmounted) so the uncontrolled inputs and the parsed header state survive
  // a round-trip through the editor.
  return (
    <>
      {isOpen && (
        <div className="tm-map-view">
          <button type="button" className="tm-back" onClick={handleModal}>
            <ArrowLeftOutlined /> Back to task
          </button>
          <p className="modal-header-text tm-map-title">Map Fields</p>
          <TaskMapFields
            sqlHeader={sqlHeader}
            fileHeader={fileHeader}
            clickPrevious={handleModal}
            confirmMapFields={mappingConfirmed}
            mappingSelection={props.mappingSelection}
            setMappingSelection={props.setMappingSelection}
            mapName={props.mapName}
            setMapName={props.setMapName}
            mappedData={props.mappedData}
            setMappedData={props.setMappedData}
            setMappedList={props.setMappedList}
            mappedList={props.mappedList}
          />
        </div>
      )}
    <div style={{ display: isOpen ? "none" : undefined }}>
      <Row>
        <Col span={6}>
          <p className="spec-modal-label">Test Suite *</p>
        </Col>
        <Col span={18}>
          <Select
            style={{ width: "100%" }}
            placeholder="select test suite"
            showSearch
            onChange={onChangeTestSuite}
            filterOption={(input, option) =>
              option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }
          >
            {props.testSuites.map((item) => (
              <Option
                key={item.testSuiteName}
                value={item.testSuiteId}
                spec={item.controlDocumentName}
              >
                {item.testSuiteName}
              </Option>
            ))}
          </Select>
        </Col>
      </Row>
      <Row>
        <Col span={6}>
          <p className="spec-modal-label">
            Match Filename *{" "}
            <Tooltip title="Enter the name of the file which should match the criteria from dropdown selection">
              <QuestionCircleOutlined
                style={{
                  color: "rgba(0,0,0,.45)",
                }}
              />
            </Tooltip>
          </p>
        </Col>
        <Col span={6}>
          <Select
            placeholder="match type"
            onChange={(e) => {
              if (e === "any") {
                setFileName("");
                setMatchDisabled(true);
              } else {
                setMatchDisabled(false);
              }
              setMatchType(e);
              props.updateMatchType(e);
            }}
            style={{ width: "80%" }}
          >
            <Option value="equals">Equals</Option>
            <Option value="contains">Contains</Option>
            <Option value="any">Any</Option>
          </Select>
        </Col>
        <Col span={12}>
          <Input
            value={fileName}
            disabled={matchDisabled}
            placeholder="file name"
            onChange={(e) => setFileName(e.target.value)}
            width="100%"
          />
        </Col>
      </Row>
      <Row>
        <Col span={6}>
          <p className="spec-modal-label">
            Delimiter *{" "}
            <Tooltip title="The character separating columns in your file. Must match the sample file's actual delimiter.">
              <QuestionCircleOutlined style={{ color: "rgba(0,0,0,.45)" }} />
            </Tooltip>
          </p>
        </Col>
        <Col span={18}>
          <Select
            placeholder="select delimiter"
            onChange={(e) => setFileType(e)}
            style={{ width: "100%" }}
          >
            <Option value="comma">Comma delimited</Option>
            <Option value="pipe">Pipe delimited</Option>
            <Option value="tab">Tab delimited</Option>
          </Select>
        </Col>
      </Row>
      <Row>
        <Col span={6}>
          <p className="spec-modal-label">
            Sample with header *{" "}
            <Tooltip title="We will only use the header from the uploaded file for mapping purposes. This is not the Test File">
              <QuestionCircleOutlined
                style={{
                  color: "rgba(0,0,0,.45)",
                }}
              />
            </Tooltip>
          </p>
        </Col>
        <Col span={18}>
          <p>
            <input
              type="file"
              onChange={(e) => {
                getContent(e.target.files[0]);
                setFile(e.target.files[0]);
              }}
              style={{ color: "black" }}
            />
          </p>
        </Col>
      </Row>
      <Row>
        <Col span={6}>
          <p className="spec-modal-label">Mapping Details *</p>
        </Col>
        <Col span={18}>
          <Button
            icon={
              isGreen && (
                <CheckOutlined
                  style={{ color: isGreen ? "green" : "default" }}
                />
              )
            }
            type="dashed"
            onClick={onMappingClick}
            style={{
              borderColor: isGreen ? "green" : "default",
              borderStyle: "dashed",
            }}
          >
            Click here to edit/view mapping
          </Button>
        </Col>
      </Row>
    </div>
    </>
  );
}

export default FileToDbTask;
